import { Capacitor } from '@capacitor/core';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

import { AppStoreLinks } from '../../../../constants';

const useStyles = makeStyles()((theme) => ({
  buttonMaxWidth: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: 340,
    },
  },
}));

type ActionButtonProps = {
  text: string;
  route: string;
  requiresUpgrade: boolean;
  popup: boolean;
  onClose?: () => void;
};

export const ActionButton = (props: ActionButtonProps): JSX.Element => {
  const { text, route, requiresUpgrade, popup, onClose } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();

  const absRoute = /http/.test(route) || requiresUpgrade;

  const title = requiresUpgrade ? t('messageDetail.button') : text;

  const getLink = (): string => {
    if (!requiresUpgrade) return route;

    if (Capacitor.getPlatform() === 'ios') {
      return AppStoreLinks.ios;
    }

    return AppStoreLinks.android;
  };

  if (absRoute) {
    return (
      <Button
        fullWidth
        className={(!popup && classes.buttonMaxWidth) || undefined}
        size="large"
        to={{ pathname: getLink() }}
        target="_blank"
        component={Link}
        onClick={onClose}
      >
        {title}
      </Button>
    );
  }

  return (
    <Button
      fullWidth
      className={(!popup && classes.buttonMaxWidth) || undefined}
      size="large"
      to={route}
      component={Link}
      onClick={onClose}
    >
      {text}
    </Button>
  );
};
